import React, { SyntheticEvent } from 'react';
import AudioControl from '../../../common/components/AudioControl';
import AudioControlPlayButton from '../../../common/components/AudioControlPlayButton';
import AudioControlSeekbar from '../../../common/components/AudioControlSeekbar';
import { MusicAlbumTrackEntity } from '../../types/MusicAlbumEntityTypes';
import { MusicEntity } from '../../types/MusicEntityTypes';

/**
 * 編集ボタン
 *
 * @param {object} props プロパティ
 * @returns コンポーネント
 */
function MusicAlbumEditForm3ListItemEditButton({
  distributable,
  onClick,
} : {
  distributable: boolean,
  onClick: () => void,
}) {
  const cancelEvent = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };
  return (
    <a href="/" onClick={(e) => { cancelEvent(e); onClick(); }}>
      {distributable && (
        <img src="/img/music/edit_bt.svg" alt="編集" className="edit" />
      )}
      {!distributable && (
        <img src="/img/music/edit_bt_not.svg" alt="未入力あり" className="edit_not" />
      )}
    </a>
  );
}

/**
 * トラックビュー
 */
function MusicAlbumEditForm3ListItemView({
  musicAlbumTrack,
  onEdit,
} : {
  musicAlbumTrack: MusicAlbumTrackEntity & {
    music: MusicEntity,
  },
  onEdit: () => void,
}) {
  return (
    <div className="song_one" key={musicAlbumTrack.id}>
      <div className={`inner ${musicAlbumTrack.is_distributable ? '' : 'not_entered'}`}>
        <AudioControl url={musicAlbumTrack.music.source_audio_url}>
          <AudioControlPlayButton />
          <div className="song_info">
            <p className="song_title">
              <span className="ttl">{`${musicAlbumTrack.track_no}. ${musicAlbumTrack.music.title}`}</span>
              {musicAlbumTrack.music.version}
            </p>
            <AudioControlSeekbar />
          </div>
        </AudioControl>
        <div className="right_bt_area">
          <MusicAlbumEditForm3ListItemEditButton
            distributable={musicAlbumTrack.is_distributable}
            onClick={() => onEdit()}
          />
        </div>
      </div>
    </div>
  );
}

/**
 * 編集可能なトラック一覧
 *
 * 原則としてステートレスに作られているので、
 * 内容の変更を反映するためには、propsのイベントハンドラを使い、
 * musicAlbumTracksを上位コンポーネントで変更する処理を実装する。
 */
export default function MusicAlbumEditForm3ListView<
  T extends MusicAlbumTrackEntity & { music: MusicEntity }
>({
  musicAlbumTracks,
  onEdit,
} : {
  musicAlbumTracks: T[],
  onEdit: (musicAlbumTrack: T) => void,
}) {
  return (
    <>
      <div className="song_list">
        {musicAlbumTracks.map((musicAlbumTrack) => (
          <MusicAlbumEditForm3ListItemView
            key={musicAlbumTrack.id}
            musicAlbumTrack={musicAlbumTrack}
            onEdit={() => onEdit(musicAlbumTrack)}
          />
        ))}
      </div>
    </>
  );
}
